import React from "react";
import { useTranslation } from "react-i18next";

// Download Section Component
const DownloadAppSection: React.FC = () => {
  const { t } = useTranslation(); // Hook to use translations

  return (
    <section
      className="relative bg-white px-4 py-20 dark:bg-slate-950 sm:px-6"
      id="download"
    >
      <div className="mx-auto max-w-7xl overflow-hidden rounded-2xl border border-slate-200 bg-slate-950 text-white shadow-2xl shadow-slate-900/15 dark:border-slate-800">
        <div className="grid grid-cols-1 items-center gap-10 p-6 sm:p-10 lg:grid-cols-[0.9fr_1.1fr] lg:p-12">
          <div className="order-2 lg:order-1">
            <img
              src="/assets/hovastore-app.png" // Replace with the image path for your app display
              alt="HovaStore App"
              className="mx-auto w-full max-w-md"
            />
          </div>

          <div className="order-1 lg:order-2">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-pink-200">
              {t("download.eyebrow")}
            </p>
            <h2 className="mt-3 text-3xl font-bold leading-tight sm:text-4xl">
              {t("download.title")}
            </h2>
            <p className="mt-5 max-w-2xl text-base leading-8 text-slate-300">
              {t("download.description")}
            </p>
            <div className="mt-7 grid gap-3 text-sm font-medium text-slate-200 sm:grid-cols-2">
              {[
                t("download.benefitSales"),
                t("download.benefitEbm"),
                t("download.benefitReports"),
                t("download.benefitShop"),
              ].map((item) => (
                <div key={item} className="flex items-center gap-3">
                  <span className="flex h-5 w-5 items-center justify-center rounded-full bg-emerald-400 text-xs font-bold text-slate-950">
                    ✓
                  </span>
                  {item}
                </div>
              ))}
            </div>
            <div className="relative z-10 mt-8 flex flex-wrap gap-4">
              <a
                href="https://play.google.com/store/apps/details?id=ai.hova.hovastore" // Replace with actual link to Google Play
                target="_blank"
                rel="noopener noreferrer"
                className="transition hover:-translate-y-0.5"
              >
                <img
                  src="/assets/playstore.png" // Replace with the image path for your app display
                  alt="HovaStore App"
                  className="h-12 w-auto"
                />
              </a>
              <a
                href="https://apps.apple.com/fr/app/hovastore/id6479642676" // Replace with actual App Store link
                target="_blank"
                rel="noopener noreferrer"
                className="transition hover:-translate-y-0.5"
              >
                <img
                  src="/assets/appstore.png" // Replace with the image path for your app display
                  alt="HovaStore App"
                  className="h-12 w-auto"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadAppSection;
